function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m16 13v6",
  stroke: "#eb711a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 16,
  cy: 23,
  fill: "#eb711a",
  r: 1
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m16.8844 1.53318c-.1732-.32796-.5136-.53318-.8844-.53318s-.7112.20522-.8844.53318l-13.85636 26.25002c-.16362.31-.15301.683.02796.9831.18097.3002.50589.4837.85639.4837h27.71281c.3505 0 .6754-.1835.8564-.4837.181-.3001.1916-.6731.028-.9831z",
  stroke: "#eb711a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
});

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.b563b7bd.svg";
export { ForwardRef as ReactComponent };